import React, { useContext, useEffect } from "react";
import { addDays, format } from "date-fns";
import { toast } from "react-toastify";
import Overlay from "../../Overlay";
import AppContext from "../../../AppContext";
import { langComponent } from "../../../constants";

//image
import SuccessArtWork from "../../../assets/workExchange/success-artwork.png";
import { ReactComponent as DownloadSvg } from "../../../assets/workExchange/download.svg";
import { ReactComponent as CopySvg } from "../../../assets/icons/copy.svg";
import TenderingDetailContext from "../../../pages/TenderingPage/context";

const PaymentSuccess = ({ onClose }) => {
  const { getLang } = useContext(AppContext);
  const { journal, cardDetails } = useContext(TenderingDetailContext);

  const TranslationSuccess = getLang(langComponent.chat);
  const TranslationWorkExchange = getLang(langComponent.workExchange);

  useEffect(() => {}, []);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    toast.success(TranslationWorkExchange("Copied transaction to clipboard"));
  };

  if (!journal) {
    return null;
  }

  const { _id, createdOn, grandTotal } = journal;

  return (
    <Overlay
      onClose={onClose}
      style={{
        alignItems: "center",
        pointerEvents: "none",
      }}
    >
      <div className="success-payment-container">
        <div className="success-payment-container-content">
          <div className="success-payment-container-content-image">
            <img src={SuccessArtWork} />
            <div className="success-payment-container-content-image__text">
              {TranslationWorkExchange("Success")}
            </div>
          </div>

          <div className="success-payment-container-content-detail">
            <div className="success-payment-container-content-detail__start">
              {TranslationWorkExchange("Transaction ID")}
            </div>
            <div className="success-payment-container-content-detail__end">
              {_id} <CopySvg onClick={() => handleCopy(_id)} />
            </div>
            <div className="success-payment-container-content-detail__start">
              {TranslationWorkExchange("Date")}
            </div>
            <div className="success-payment-container-content-detail__end">
              {format(addDays(new Date(createdOn), 0), "dd/MM/yyyy")}
            </div>
            {cardDetails?.cardNo && (
              <>
                <div className="success-payment-container-content-detail__start">
                  {TranslationWorkExchange("Type payment")}
                </div>
                <div className="success-payment-container-content-detail__end">
                  {TranslationSuccess("Credit card")}{" "}
                  {cardDetails.cardNo.substring(cardDetails.cardNo.length - 3)}
                </div>
              </>
            )}
            <div className="success-payment-container-content-detail__start">
              {TranslationSuccess("Price")}
            </div>
            <div className="success-payment-container-content-detail__end">
              {TranslationWorkExchange("THB")} {grandTotal.toLocaleString()}
            </div>
          </div>
          <div className="success-payment-container-content-footer">
            <div
              className="success-payment-container-content-footer__btn"
              onClick={onClose}
            >
              {TranslationWorkExchange("Done")}
            </div>
          </div>
        </div>
      </div>
    </Overlay>
  );
};

PaymentSuccess.propTypes = {};

export default PaymentSuccess;
